module.exports = __webpack_public_path__ + "static/media/clipboard.0d3a79bc.svg";